import { createContext, useContext, useState, useEffect } from 'react';
import AppParamsAPI from '~/api/appParamApi';

const AppParamsContext = createContext();

export function AppParamsProvider({ children }) {
    const [appParams, setAppParams] = useState([]);

    useEffect(() => {
        AppParamsAPI.getAll()
            .then(res => {
                const data = res.data?.Data || res.data?.data || res.data;
                setAppParams(Array.isArray(data) ? data : []);
            })
            .catch(err => console.error("Failed to load application parameters", err));
    }, []);

    const getParamValueById = (paramId) => {
        const param = appParams.find(p => p.ApplicationParamId === paramId || p.applicationParamId === paramId);
        return param ? (param.ParamValue || param.paramValue || "") : "";
    };

    return (
        <AppParamsContext.Provider value={{ appParams, getParamValueById }}>
            {children}
        </AppParamsContext.Provider>
    );
}

export const useAppParams = () => useContext(AppParamsContext);
